var WebinarRegistration = require("components/support/WebinarRegistration");

require("users/teachers/paywall_link.scss");

class PaywallLink extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { showWebinarReg: false };
	}

	showWebinarRegistration() {
		this.setState({ showWebinarReg: true });
	}

	render() {
		if (this.props.featureLocation == PaywallLink.STUDENT_ROSTER) {
			if (this.state.showWebinarReg) {
				var webinarRegistrationDisplay = (<WebinarRegistration sourceFeature={ this.props.featureLocation } />);
			} else {
				var paywallText = (
					//<p className="paywallText studentRosterPaywall">
						// Want more differentiation? With <i>Whooo's Reading School</i>, 
						// access your students' reading levels and get questions customized to their levels.
						// Chat with us and see if <i>Whooo's Reading School</i> is a good fit for your school.
					//</p>
					<p className="paywallText studentRosterPaywall">
						Want to learn more about <i>Whooo's Reading</i>?
						Attend one of our webinars to learn how you and your students can use <i>Whooo's Reading</i> as effectively as possible.
					</p>
				)
				var buttonClass = "buttonDefault"
				var containerClass = "studentRosterBlurb";
				var ctaButton = (
					<a className={ buttonClass + " btn paywallLinkButton" } onClick={ this.showWebinarRegistration }>
						Reserve a Webinar Spot
					</a>
				);
			}

		} else if (this.props.featureLocation == PaywallLink.INSIGHTS) {
			var paywallText = (
				<p className="paywallText insightsPaywall">
					Want to see your students' strengths and learning gaps for your state's standards? 
					Chat with us and see if <i>Whooo's Reading School</i> is a good fit for your school.
				</p>
			)
			var buttonClass = "buttonSuccess insightsPaywallBtn";
			var linkEventHandler = Mycroft.buildEventHandler({
				category: "Paywall", action: "schedule-consultation", label: this.props.featureLocation
			});
			var ctaButton = (
				<a href="https://calendly.com/whooos-reading/wrs-consultation"
					className={ buttonClass + " btn paywallLinkButton" } target="_blank" onClick={ linkEventHandler }>
					Schedule My Consultation
				</a>
			);
		}

		return (
			<div className={ "paywallBlurbContainer " + containerClass}>
				{ paywallText }
				{ ctaButton }
				{ webinarRegistrationDisplay }
			</div>
		)
	}
}

PaywallLink.propTypes = StrictPropTypes({
	featureLocation: PropTypes.string
});

PaywallLink.STUDENT_ROSTER = "student-roster-page";
PaywallLink.INSIGHTS = "insights-page";

module.exports = PaywallLink;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/PaywallLink.js